import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import cx from 'classnames';

import s from './OrganicNavigation.module.css';

type NavItemProps = {
  to: string;
  className?: string;
  children: React.ReactNode;
  newTab?: boolean;
  onClick?: () => void;
  ariaLabel?: string;
};

export const OrganicNavItem = ({
  children,
  to,
  className,
  newTab,
  onClick,
  ariaLabel,
}: NavItemProps) => {
  const { route } = useRouter();

  const isCurrent = route === to;

  return (
    <li className={cx(s.navItem, { [s.navItemCurrent]: isCurrent }, className)}>
      {newTab ? (
        <a
          href={to}
          target="_blank"
          rel="noreferrer"
          onClick={onClick}
          {...(ariaLabel ? { ariaLabel } : {})}
        >
          {children}
        </a>
      ) : (
        <Link href={to} onClick={onClick} aria-label={ariaLabel}>
          {children}
          {isCurrent ? (
            <span className={s.navItemCurrentA11yHidden}>
              {' -  Current location'}
            </span>
          ) : null}
        </Link>
      )}
    </li>
  );
};
